<template>
  <nuxt-link
    class="ArticleListingCard group"
    :to="'/' + story.full_slug"
  >
    <div class="relative overflow-hidden">
      <nuxt-img
        v-if="story.content?.summaryImage?.filename"
        preset="standard"
        loading="lazy"
        sizes="sm:100vw desk:404px"
        :src="story.content.summaryImage.filename"
        :alt="story.content.summaryTitle"
        class="w-full object-cover aspect-wide group-hover:scale-110 transition-transform duration-500"
      />
      <div
        v-if="story.content.summaryTime"
        class="absolute bottom-12 left-12 pr-8 desk:pr-12 pl-4 h-20 desk:h-24 flex justify-center items-center gap-6 desk:gap-8 bg-darkest text-lightest type-headline-xxs desk:type-headline-xs opacity-90"
      >
        <img
          src="/icons/play-filled-inv.svg"
          class="w-8 h-8 desk:w-12 desk:h-12"
        >
        <span> {{ story.content.summaryTime }} </span>
      </div>
    </div>
    <div class="px-12 pt-16 flex flex-col items-start gap-8">
      <div
        v-if="story.content.summaryCategories"
        class="type-tagline dotted-border"
      >
        {{ $t(`articles.keyword.${story.content.summaryCategories}`) }}
      </div>
      <div>{{ story.content.summaryTitle }}</div>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
import { StoryBlokArticlePage } from '#constants/types/storyblok';

defineProps<{
  story: StoryBlokArticlePage,
}>();

</script>

<style scoped lang="postcss">
</style>
